// ** ThemeConfig Import
import themeConfig from "@src/views/v2/configs/themeConfig";

// ** Returns Initial Menu Collapsed State
const initialMenuCollapsed = () => {
  const item = window.localStorage.getItem("menuCollapsed");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.menu.isCollapsed;
};

// ** Initial State
const initialState = {
  isRTL: themeConfig.layout.isRTL,
  menuCollapsed: initialMenuCollapsed(),
  menuHidden: themeConfig.layout.menu.isHidden,
  contentWidth: themeConfig.layout.contentWidth,
  orgId: "",
  create_Org: "",
  all_user_organizations: [],
  organizationLoading: true,
  deleteOp: { id: "", moduleName: "" },
  userNoti: "",
  notiCount: "",
  sessionAlert: false,
  translations: {},
  theme: {
    appName: "",
    primaryColor: "",
    secondaryColor: "",
    favicon: "",
    defaultLogo: "",
    whiteLogo: "",
    updatedAt: "",
  },
  dynamicLabels: null,
};

const layoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case "HANDLE_CONTENT_WIDTH":
      return { ...state, contentWidth: action.value };
    case "HANDLE_MENU_COLLAPSED":
      window.localStorage.setItem("menuCollapsed", action.value);
      return { ...state, menuCollapsed: action.value };
    case "HANDLE_MENU_HIDDEN":
      return { ...state, menuHidden: action.value };
    case "HANDLE_RTL":
      localStorage.setItem("isRTL", action.value ? "yes" : "no");
      return { ...state, isRTL: action.value };
    case "Active_Org":
      localStorage.setItem("orgId", action.value);

      return { ...state, orgId: action.value };
    case "Create_Org":
      return { ...state, create_Org: action.value };
    case "Delete_Operation":
      return { ...state, deleteOp: action.value };
    case "Clear_Delete_Operation":
      return { ...state, deleteOp: {} };
    case "Restore_Operation":
      return { ...state, restoreOp: action.value };
    case "Clear_Restore_Operation":
      return { ...state, restoreOp: {} };
    case "User_Data":
      localStorage.setItem("Users-data", "action.value");
      return { ...state, orgId: action.value };
    case "User_Noti":
      return { ...state, userNoti: action.value };
    case "noti_count":
      return { ...state, notiCount: action.value };
    case "handle_event":
      return { ...state, sessionAlert: action.value };
    case "set_all_user_organizations":
      return {
        ...state,
        all_user_organizations: action.value,
        organizationLoading: false,
      };
    case "update_theme_settings":
      const themeSettings = {
        appName: action.value.app_name || state.theme.appName,
        primaryColor: action.value.primary_color || state.theme.primaryColor,
        secondaryColor:
          action.value.secondary_color || state.theme.secondaryColor,
        favicon: action.value.favicon || state.theme.favicon,
        defaultLogo: action.value.default_logo || state.theme.defaultLogo,
        whiteLogo: action.value.white_logo || state.theme.whiteLogo,
        updated_at: action.value.updated_at,
      };
      return {
        ...state,
        theme: themeSettings,
      };

    case "update_app_translation":
      const translations = {};
      if (action?.value?.pagination?.length > 0) {
        action.value.pagination.forEach((item) => {
          translations[item.english] = item.arabic;
        });
      }
      return {
        ...state,
        translations,
      };

    case "set_dynamic_labels":
      const dynamicLabels = {};
      let payload = action.value || state.dynamicLabels;
      if (payload?.length > 0) {
        payload.map((dynamicLabel) => {
          const parsedLabel = {
            ...dynamicLabel,
            label: dynamicLabel?.key?.replace("_", " "),
          };
          dynamicLabels[dynamicLabel.key] = parsedLabel;
          return dynamicLabel;
        });
      }
      return { ...state, dynamicLabels };
    default:
      return state;
  }
};

export default layoutReducer;
